module.exports = "<div class=time-range><span class=from-value>{{rangeValues.convertedModel}}</span> &mdash; <span class=to-value>{{rangeValues.convertedRange}}</span></div><div slider class=range-slider ng-model=rangeValues.model ng-model-range=rangeValues.range floor={{rangeValues.floor}} ceiling={{rangeValues.ceiling}} precision=2 step=300000 stretch=3></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/templates/time-range.tmpl.html
// module id = 551
// module chunks = 0